import { useState } from "react";

// From https://codesandbox.io/s/upbeat-sun-zgyyo5?file=/src/hooks/useScrollWithShadow.js:0-1033
// https://www.dfindconsulting.no/bloggen/react-scroll-hook-with-shadows

export function useInfiniteShadowScroll(showTopShadow = true, showBottomShadow = true, bottomThreshold: number = 20) {
  const [scrollTop, setScrollTop] = useState(0);
  const [scrollHeight, setScrollHeight] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const [hasScrolled, setHasScrolled] = useState(false);
  const onScrollHandler = (event: any) => {
    if (!hasScrolled) {
      setHasScrolled(true);
    }
    setScrollTop(event.target.scrollTop);
    setScrollHeight(event.target.scrollHeight);
    setClientHeight(event.target.clientHeight);
  };

  function getBoxShadow(_showTopShadow = true, _showBottomShadow = true) {
    const isBottom = clientHeight === scrollHeight - scrollTop;

    const isTop = scrollTop === 0;
    const isBetween = scrollTop > 0 && clientHeight < scrollHeight - scrollTop;

    let boxShadow = "none";
    const top = `inset 0 ${scrollTop > 0 ? Math.min(scrollTop * 0.15, 6) : 0}px 5px -5px rgba(0,0,0, 0.2)`;
    const bottom = "inset 0 -8px 5px -5px rgba(0,0,0, 0.2)";

    if (_showTopShadow && _showBottomShadow) {
      if (isTop) {
        boxShadow = bottom;
      } else if (isBetween) {
        boxShadow = `${top}, ${bottom}`;
      } else if (isBottom) {
        boxShadow = top;
      }
    } else if (_showTopShadow) {
      if (!isTop) {
        boxShadow = top;
      }
    } else if (_showBottomShadow) {
      if (!isBottom) {
        boxShadow = bottom;
      }
    }

    return { boxShadow: boxShadow };
  }

  function isAtBottom() {
    if (!hasScrolled) {
      return false;
    }
    const isAB = clientHeight + bottomThreshold >= scrollHeight - scrollTop;

    return isAB;
  }

  return { boxShadow: getBoxShadow(showTopShadow, showBottomShadow), onScrollHandler, isAtBottom: isAtBottom() };
}
